import { find, isEmpty } from 'lodash'

const isNotArchived = (entity) => entity?.isArchived !== true

export const isOutletCatalogProduct = (product) =>
  product?.isActive === true && product?.isArchived === false

export const filterOutletCatalogProducts = ({
  products = [],
  brands = [],
  categories = [],
  remains = [],
  brandIds = [],
}) => {
  const brandFilter = brandIds.length > 0 ? new Set(brandIds) : null
  const remainsList = remains?.remains || remains || []

  return products
    .filter(isOutletCatalogProduct)
    .filter((product) => {
      if (brandFilter && !brandFilter.has(product.brandId)) {
        return false
      }

      return true
    })
    .map((product) => {
      const brandData = find(brands, { id: product.brandId })
      const categoryData = find(categories, { id: product.categoryId })

      if (!isNotArchived(brandData) || !isNotArchived(categoryData)) {
        return null
      }

      const subcategoryData = categoryData
        ? (categoryData.subcategories || []).find(
            (item) => String(item.id) === String(product.subcategoryId)
          )
        : null

      const remainsData = find(remainsList, {
        productId: product.id,
      })
      const quantity = !isEmpty(remainsData) ? remainsData.quantity : 0

      if (quantity <= 0) {
        return null
      }

      return {
        ...product,
        brandName: brandData ? brandData.name : '',
        categoryName: categoryData ? categoryData.name : '',
        subcategoryName: subcategoryData ? subcategoryData.title : product.subcategoryName || '',
        quantity,
      }
    })
    .filter(Boolean)
}

export default filterOutletCatalogProducts
